import { useQuery, useMutation } from "@tanstack/react-query";
import clientPortalAxiosInstance from "../../common/utilities/axios/clientPortalAxiosInstance";
import adminAxiosInstance from "../../common/utilities/axios/adminAxiosInstance";
import sleep from "sleep-promise";
import clientPortalAxiosInstanceForFileDownLoad from "../../common/utilities/axios/clientPortalAxiosInstanceForFileDownLoad";


export const useGetAllManageRefListQuery = ({ loggedInUserId }) => {
  return useQuery({
    queryKey: ["getAllManageRefListQuery", loggedInUserId],
    queryFn: () => {

      console.log("loggedInUserId123:", loggedInUserId)
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/User-Profile/client/AllmanageReferralRequest/${loggedInUserId}`)
        .then((res) => {
          return res.data;
        });
    },
    // The query will not execute until the Id exists
    enabled: !!loggedInUserId,
  });
};

// /User-Profile/client/AllRequestStatusList
export const useGetAllRequestStatusListQuery = () => {
  return useQuery({
    queryKey: ["getReferralsListQuery"],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/User-Profile/client/AllRequestStatusList`)
        .then((res) => res.data);
    },
  });
};

// api - get admin accounts list
export const useGetAccountAdminListQuery = () => {
  return useQuery({
    queryKey: ["getAccountAdminList"],
    queryFn: () => {
      // sleep(2000);
      return adminAxiosInstance
        .get(`/getAccountAdminList`)
        .then((res) => res.data);
    },
  });
};
// /User-Profile/client/AllRequestStatusList
export const useGetAllRefReqStatusListQuery = () => {
  return useQuery({
    queryKey: ["getAllRefReqStatusListQuery"],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/User-Profile/client/AllRequestStatusList`)
        .then((res) => res.data);
    },
  });
};

// api for update /client/UpdateReferralRequest
export const useViewReferralsListMutation = () => {
  return useMutation({
    mutationFn: ({ loggedInUserId, roleId, isEnterpriseAdmin }) => {
      return clientPortalAxiosInstance.post(`User-Profile/client/rolebasedAllreferralRequest`, {
        "LoggedInUserId": loggedInUserId || "",
        "RoleId": roleId || "",
        "IsEnterpriseAdmin": isEnterpriseAdmin
      })
    },
  })
}

export const useUpdateRefReqMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      return clientPortalAxiosInstance.put(
        `/User-Profile/client/UpdateReferralRequest`,
        body
      );
    },
  });
};

// api - for getting download file by id and branch id.
export const useGetDownloadRefFileQuery = ({ Id, BrandId }) => {
  return useQuery({
    queryKey: ["getDownloadRefFileQuery", `${Id}`, `${BrandId}`],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstanceForFileDownLoad
        .get(`/client-referral/referral/details/${Id}/${BrandId}`)
        .then((res) => {
          let contentTypeHeader = res.headers["content-type"];

          /**converting binary file to blob here */
          var blob = new Blob([res.data], {
            type: contentTypeHeader.toLowerCase(),
            charset: "UTF-8",
          });
          return blob;
        });
    },
    enabled: !!Id && !!BrandId,
  });
};

// api for getting ref request details by id
export const useGetRefReqByIdQuery = ({ Id }) => {
  return useQuery({
    queryKey: ["getRefReqByIdQuery", `${Id}`],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/User-Profile/client/getReferralRequestbyId/${Id}`)
        .then((res) => {
          return res.data;
        });
    },
    // The query will not execute until the Id exists
    enabled: !!Id,
  });
};

// api for update /client/UpdateReferralRequest
export const useUpdateManageRefReqMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      return clientPortalAxiosInstance.put(
        `/User-Profile/client/UpdateManageReferralRequest`,
        body
      );
    },
  });
};
